import {
  LOGIN_ANOTHER_WAY_REQUEST,
  LOGIN_ANOTHER_WAY_SUCCESS,
  LOGIN_ANOTHER_WAY_FAILURE,
  RESET_LOGIN_ANOTHER_WAY_STATE,
} from "../../actionTypes/loginAnotherWay";

interface LoginAnotherWayPayload {
  emailOrPhone: string;
}

export const loginAnotherWayRequest = (payload: LoginAnotherWayPayload) => ({
  type: LOGIN_ANOTHER_WAY_REQUEST,
  payload,
});

export const loginAnotherWaySuccess = (response: string) => ({
  type: LOGIN_ANOTHER_WAY_SUCCESS,
  payload: response,
});

export const loginAnotherWayFailure = (response: string) => ({
  type: LOGIN_ANOTHER_WAY_FAILURE,
  payload: response,
});

export const resetloginAnotherWayState = () => ({
  type: RESET_LOGIN_ANOTHER_WAY_STATE,
});
